import React, { Component } from 'react';
import classes from './FacebookIcon.module.scss';
import { getFileName } from 'helpers/FileCaching';
import globalJSON from 'data/global.json';
const socialIcons = require.context('images/components/Articles/Article/SocialIcons', true, /.*\.(gif|png|jpe?g|svg)$/i);
// const socialIcons = require.context('images/components/Global/icons', true, /.*\.(gif|png|jpe?g|svg)$/i);

class FacebookIcon extends Component {

    constructor(props){

        super(props);
        
        this.state = {
            imgSrc: getFileName(socialIcons, 'facebook-1.svg'),
            showPopup: false
          
         };

   
    
        //  this.handleMouseOver = this.handleMouseOver.bind(this);
        //  this.handleMouseOut = this.handleMouseOut.bind(this);

    }

    // handleMouseOver() {
    //     this.setState({
    //       imgSrc: getFileName(socialIcons, 'facebook-icon-hover.svg')
    //     });
    // }

    // handleMouseOut() {
    //     this.setState({
    //         imgSrc: getFileName(socialIcons, 'facebook-1.svg')
    //     });
    // }

    showModal = () => {
        this.setState({ show: true });
      };
    
      hideModal = () => {
        this.setState({ show: false });
      };

    popUp = (e) => {
      e.preventDefault();
      let type = e.currentTarget.getAttribute('data-social');
      console.log(type);
      let link = e.currentTarget.getAttribute('href');
      
      // if(type == "twitter"){
      //     link = encodeURI(link);
      // }
      console.log(link);
      popupCenter(link,'xtf','500','500');
    }

    onClick(event){

      window.gtag('event', "clicked to share on facebook", {
      	'event_category': globalJSON.tracking.ga_category,
      	'event_label': "clicked to share article "+ event.currentTarget.attributes['data-url'].value + " on facebook",
      	'value':10
        });
      
      console.log("clicked to share article "+ event.currentTarget.attributes['data-url'].value + " on facebook")
    }


    render(){
        let style ={
            // WebkitTransition: 'all 50s ease-in 50s', // note the capital 'W' here
            // msTransition: 'all 50s ease-in 50s' // 'ms' is the only lowercase vendor prefix
        }

        let animationTiming ={
            enter: 400,
            exit:1000
        }

        return (
                <li className={`socialIcons__item`}>
                  <div className={`socialIcons__wrapper`}>
                    <a className={classes.socialIcons__link} onClick={this.popUp}  onClick={this.onClick} data-social="facebook" target="_blank" rel="noopener" href={`http://www.facebook.com/sharer/sharer.php?u=${this.props.url}&quote=${this.props.facebookDescription}`} data-url={this.props.url}>
                    {/* <img className={`facebookIcon ${classes.socialIcons__img}`} style={style} onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut} src={this.state.imgSrc}/> */}
                        <img className={`facebookIconHover ${classes.socialIcons__imgHover}`} src={getFileName(socialIcons, 'facebook-icon-hover.svg')} alt="share"/>
                        <img className={`facebookIcon ${classes.socialIcons__img}`} style={style}  src={this.state.imgSrc} alt="share"/>
                    </a>
                  </div>
                </li>
        );
    }
}

  const popupCenter = (url, title, w, h) => {

    const dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : this.screen.left;
    const dualScreenTop = window.screenTop != undefined ? window.screenTop : this.screen.top;

    const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : this.screen.width;
    const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : this.screen.height;

    const left = ((width / 2) - (w / 2)) + dualScreenLeft;
    const top = ((height / 2) - (h / 2)) + dualScreenTop;
    const newWindow = window.open(url, title, 'status=yes,toolbar=no,menubar=no,location=no,width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
    
    if (window.focus) {
        newWindow.focus();
    }

}

export default FacebookIcon;
